import { combineReducers } from "redux";
import liveset from "./liveset";
import samples from "./samples";

export default combineReducers({
  liveset,
  samples,
});
